import { getFromLocalStorage } from '../../hooks/useLocalStorage';
import { UPDATE_CASHIFY_POLICY_PAYLOAD, UPDATE_CASHIFY_POLICY_PAYLOAD_RESET, UPDATE_CASHIFY_POLICY_PAYLOAD_SUCCESS, UPDATE_POLICY_PAYLOAD, UPDATE_POLICY_PAYLOAD_RESET, UPDATE_POLICY_PAYLOAD_SUCCESS } from '../actionTypes'


export const cashifyPolicyInitialState = {
    coverageDetails: {
        vin: '',
        brand: '',
        model: '',
        amount: '',
        invoice_no: '',
        invoice_date: '',
    },
    customerDetails: {
        name: '',
        email: '',
        mobile: '',
        address: '',
        pin_code: '',
        country: '',
        state: '',
        city: '',
    },
    product: { product_id: '', product_name: '', amount: 0 , policyId: '',product_details: {},products: [] },
    
}

export default (state = cashifyPolicyInitialState, action) => {
    switch (action.type) {
        case UPDATE_CASHIFY_POLICY_PAYLOAD:
            return { ...state, ...action.payload?.policy };
        case UPDATE_CASHIFY_POLICY_PAYLOAD_SUCCESS:
            return { ...state, ...action.payload };
        case UPDATE_CASHIFY_POLICY_PAYLOAD_RESET:
            return { ...state, ...cashifyPolicyInitialState };
        default: return state;
    }

}